module.exports = {
      id: "search-usage",
      viewBox: "0 0 15 16",
      url: __webpack_public_path__ + "sprite-99dfb162d59834e1e55e619b64a45f56.svg#search",
      toString: function () {
        return this.url;
      }
    }